const hasOwn = Object.prototype.hasOwnProperty
export default hasOwn
